const PRICE_FIELDS = ['price', 'origin', 'cost']

const isPlainObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value)

const pickPriceObject = (goods) => {
  if (!goods || typeof goods !== 'object') return null

  if (isPlainObject(goods.price)) {
    return goods.price
  }

  const prices = Array.isArray(goods.prices) ? goods.prices : []
  if (prices.length > 0 && isPlainObject(prices[0])) {
    return prices[0]
  }

  return null
}

export const getHotelGoodsPriceField = (goods, field = 'price', fallback = '-') => {
  if (!PRICE_FIELDS.includes(field) || !goods || typeof goods !== 'object') {
    return fallback
  }

  const priceObject = pickPriceObject(goods)
  if (priceObject && priceObject[field] != null) {
    return priceObject[field]
  }

  if (field === 'price' && goods.price != null && !isPlainObject(goods.price)) {
    return goods.price
  }

  if (goods[field] != null && !isPlainObject(goods[field])) {
    return goods[field]
  }

  return fallback
}

export const getHotelGoodsPriceNumber = (goods, field = 'price') => {
  const value = getHotelGoodsPriceField(goods, field, null)
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

export const formatHotelGoodsPrice = (value, fallback = '-') => {
  const parsed = Number(value)
  if (!Number.isFinite(parsed)) return fallback
  return `$${new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(parsed)}`
}

export const getHotelGoodsPriceDisplay = (goods, field = 'price', fallback = '-') => {
  const value = getHotelGoodsPriceField(goods, field, null)
  if (value == null || value === '') return fallback
  return formatHotelGoodsPrice(value, fallback)
}
